import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, OnInit, Output, input, effect, signal } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FormsModule } from "../../../../shared/components/forms/forms.module";
import moment from 'moment';
import { filterFromdateList } from 'src/app/shared/models/filter';
import { ProvidersQPS } from 'src/app/core/services/providers.service';
import { MaterialModule } from 'src/app/material/material.module';
import { PROVIDER_STATUS } from 'src/app/core/enums/providerStatus';
import { MapsService } from 'src/app/shared/services/maps.service';
import { Observable, Subscription } from 'rxjs';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { ProviderByStatusAndLocation } from 'src/app/core/enums/ProviderByStatusAndLocation';
import { PATIENT_STATUS } from 'src/app/core/enums/patientStatus';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-filter-by-agreements',
    standalone: true,
    imports: [FormsModule, MaterialModule, CommonModule],
    templateUrl: './filter-by-agreements.component.html',
    styleUrl: './filter-by-agreements.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ display: 'none' })),
            state('expanded', style({ display: 'visible' })),
            transition('expanded <=> collapsed', animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            transition('expanded <=> void', animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})
export class FilterByAgreementsComponent implements OnInit {
    public readonly INCLUDE_PROVIDERS_PERSONAL_ADDRESS = 'includeProvidersAddress';
    public readonly INCLUDE_PROVIDERS_ZONE = 'includeProvidersZone';
    public readonly INCLUDE_ENABLED_PROVIDERS = 'includeEnabledProviders';
    public readonly INCLUDE_DISABLED_PROVIDERS = 'includeDisabledProviders';
    public readonly INCLUDE_PATIENTS = 'includePatients';
    public readonly INCLUDE_ACTIVE_PATIENTS = 'includeActivePatients';
    public readonly INCLUDE_INACTIVE_PATIENTS = 'includeInactivePatients';
    public readonly FROMDATE = 'fromDate';
    public readonly INCLUDE_ACTIVE_PROVIDERS ='includeActiveProviders';
    public readonly INCLUDE_POSSIBLE_PROVIDERS = 'includeInactvePossibleProviders';
    public readonly INCLUDE_CANCELLED_PROVIDERS = 'includeInactiveCancelledProviders';
    public readonly INCLUDE_INACTIVE_PROVIDERS = 'includeInactiveProviders';

    filtersForm: FormGroup;
    filterVisible: boolean = true;
    // checksFiltersEnabled: boolean = false;
    loadingProvidersFilters = false;
    loadingPatientsFilters = false;
    screenCalling = input<string>();
    providersCheck: boolean = false;
    patientsCheck: boolean = false;
    patientsFiltersVisible: boolean = true;
    providersFiltersVisible: boolean = true;
    activePatientsSelected = false;
    inactivePatientsSelected = false;
    providerStatus = PROVIDER_STATUS;
    patientStatus = PATIENT_STATUS;
    includProvidersAddressChecked = true;
    includeProvidersZoneChecked = true;

    activeProvidersSelected = signal(false);
    inactiveProvidersSelected = signal(false);
    possibleProvidersSelected = signal(false);
    cancelledProvidersSelected = signal(false);

    _loadingProviders: Subscription;
    //loading flags
    isLoadingActiveAddress   = false;
    isLoadingActiveZone      = false;
    isLoadingPossibleAddress = false;
    isLoadingPossibleZone    = false;
    isLoadingCancelledAddress= false;
    isLoadingCancelledZone   = false;
    isLoadingInactiveAddress = false;
    isLoadingInactiveZone    = false;

    loadingActive$              : Observable<boolean>;
    loadingInactivePossible$    : Observable<boolean>;
    loadingInactiveCancelled$   : Observable<boolean>;
    loadingInactive$            : Observable<boolean>;


    @Input() isExpanded: boolean = false;
    @Input() enableFilters: boolean = false;

    @Output('onChangeExpand') onChangeExpandEvent = new EventEmitter<boolean>();
    @Output() patientActiveFilter = new EventEmitter<boolean>();
    @Output() patientInactiveFilter = new EventEmitter<boolean>();
    @Output() statusFilterEmitter = new EventEmitter<{ value: boolean; name:string }>();
    @Output() providerLocationFilter = new EventEmitter<{ value: boolean; filter: ProviderByStatusAndLocation[] }>();
    @Output() patientByStatusFilter = new EventEmitter<{value:boolean; status:PATIENT_STATUS}>();
    @Output() showPatients = new EventEmitter<boolean>();
    @Output() fromDateToQps = new EventEmitter<Date>();
    @Output() providerByStatusFilterEmitter = new EventEmitter<{ value: boolean; name:string }>();


    disableActions: boolean = false;
    showPatientsFilters: boolean = false;
    providerQPS_Default: ProvidersQPS = {
        active: true,
        isSupply: false,
        isFilteredByRegion: false,
    };
    fromDateList: filterFromdateList[] = [
        {
            id: 1,
            description: 'Último mes',
            value: moment().subtract(1, 'months').startOf('month')
        },
        {
            id: 2,
            description: 'Ûltimos 2 meses',
            value: moment().subtract(2, 'months').startOf('month')
        },
        {
            id: 3,
            description: 'Ûltimos 3 meses',
            value: moment().subtract(3, 'months').startOf('month')
        },
        {
            id: 6,
            description: 'Ûltimos 6 meses',
            value: moment().subtract(6, 'months').startOf('month')
        },
        {
            id: 9,
            description: 'Ûltimos 9 meses',
            value: moment().subtract(9, 'months').startOf('month')
        },
        {
            id: 12,
            description: 'Ûltimos 12 meses',
            value: moment().subtract(12, 'months').startOf('month')
        },
    ]
    fromDateSelected: Date = this.fromDateList[5].value.toDate();
    fromDateListSelected:filterFromdateList = this.fromDateList[5];

    constructor(
        private formBuilder: FormBuilder,
        private mapsService: MapsService,
        private entitiesFacade: EntitiesFacade,
    ) {
        this.loadingActive$ = this.entitiesFacade.getLoadingByStatusAndLocation$(
            ProviderByStatusAndLocation.ACTIVE_ADDRESS
          );

          this.loadingInactivePossible$ = this.entitiesFacade.getLoadingByStatusAndLocation$(
            ProviderByStatusAndLocation.INACTIVE_POSSIBLE_ADDRESS
          );

          this.loadingInactiveCancelled$ = this.entitiesFacade.getLoadingByStatusAndLocation$(
            ProviderByStatusAndLocation.INACTIVE_CANCELLED_ADDRESS
          );

          this.loadingInactive$ = this.entitiesFacade.getLoadingByStatusAndLocation$(
            ProviderByStatusAndLocation.INACTIVE_ADDRESS
          );
    }

    setFilterVisible() {
        this.filterVisible = !this.filterVisible;
    }

    createFiltersForm() {
        return this.formBuilder.group({
            arrangement: new FormControl({ disabled: false }),
            [this.INCLUDE_PATIENTS]: [{ disabled: !this.enableFilters, value: '' }],
            [this.INCLUDE_ACTIVE_PATIENTS]: [{ disabled: !this.enableFilters, value: '' }],
            [this.INCLUDE_INACTIVE_PATIENTS]: [{ disabled: !this.enableFilters, value: '' }],
            [this.INCLUDE_PROVIDERS_PERSONAL_ADDRESS]: [{ disabled: !this.enableFilters, value: 'true' }],
            [this.INCLUDE_PROVIDERS_ZONE]: [{ disabled: !this.enableFilters, value: 'true' }],
            [this.FROMDATE]: [{ disabled: !this.enableFilters, value: '' }],
            [this.INCLUDE_ACTIVE_PROVIDERS]: [{ disabled: !this.enableFilters, value: 'true' }],
            [this.INCLUDE_INACTIVE_PROVIDERS]: [{ disabled: !this.enableFilters, value: 'false' }],
            [this.INCLUDE_CANCELLED_PROVIDERS]: [{ disabled: !this.enableFilters, value: 'true' }],
            [this.INCLUDE_POSSIBLE_PROVIDERS]: [{ disabled: !this.enableFilters, value: 'true' }],
        });
    }

    calculateIdFromDate(state) {
        return state != null ? state.id : null
    }

    calculateNameFromDate(state) {
        return state != null ? state.description : null
    }

    loadingProvidersFilterSpinner() {
        this.loadingProvidersFilters = true;
        setTimeout(() => {
            this.loadingProvidersFilters = false;
        }, 500);
    }

    loadingPatientsFilterSpinner() {
        this.loadingPatientsFilters = true;
        setTimeout(() => {
            this.loadingPatientsFilters = false;
        }, 500);
    }

    get fromDateSelect() {
        return this.filtersForm.get(this.FROMDATE).value;
    }
    set fromDateSelect(value) {
        console.log(value);
    }

    ngOnInit(): void {
        this.filtersForm = this.createFiltersForm();
        this.filtersForm.get('includeActivePatients').valueChanges.subscribe(value => {
            if (value) {
                this.patientActiveFilter.emit(true);
            } else {
                this.patientActiveFilter.emit(false);
            }
            this.loadingPatientsFilterSpinner();
        })
        this.filtersForm.get('includeInactivePatients').valueChanges.subscribe(value => {
            if (value) {
                this.patientInactiveFilter.emit(true)
            } else {
                this.patientInactiveFilter.emit(false)
            }
            this.loadingPatientsFilterSpinner();
        });
        this.filtersForm.get('includeProvidersAddress').valueChanges.subscribe(value => {
            this.includProvidersAddressChecked = value
                this.providerLocationFilter.emit({value: value, filter: this.mapsService.matchProvidersStatusAndLocation('ADDRESS')})
            this.loadingProvidersFilterSpinner();
        });
        this.filtersForm.get('includeProvidersZone').valueChanges.subscribe(value => {
            this.includeProvidersZoneChecked = value
            this.providerLocationFilter.emit({value: value, filter: this.mapsService.matchProvidersStatusAndLocation('ZONE')})
            this.loadingProvidersFilterSpinner();
        });
        this.filtersForm.get('includePatients').valueChanges.subscribe(value => {
            // console.log('tocaste check pacientes',value);

            this.showPatientsFilters= value;
            this.showPatients.emit(value);
        });


        this._loadingProviders = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.ACTIVE_ADDRESS)
        .subscribe((isLoading) => this.isLoadingActiveAddress = isLoading);

        this._loadingProviders = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.ACTIVE_ZONE)
        .subscribe((isLoading) => this.isLoadingActiveZone = isLoading);

        this._loadingProviders= this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_POSSIBLE_ADDRESS)
        .subscribe((isLoading) => this.isLoadingPossibleAddress = isLoading);

        this._loadingProviders = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_POSSIBLE_ZONE)
        .subscribe((isLoading) => this.isLoadingPossibleZone = isLoading);

        this._loadingProviders   = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_CANCELLED_ADDRESS)
        .subscribe((isLoading) => this.isLoadingCancelledAddress = isLoading);

        this._loadingProviders     = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_CANCELLED_ZONE)
        .subscribe((isLoading) => this.isLoadingCancelledZone = isLoading);

        this._loadingProviders   = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_ADDRESS)
        .subscribe((isLoading) => this.isLoadingInactiveAddress = isLoading);

        this._loadingProviders      = this.entitiesFacade.getLoadingByStatusAndLocation$(ProviderByStatusAndLocation.INACTIVE_ZONE)
        .subscribe((isLoading) => this.isLoadingInactiveZone = isLoading);

    }

    setPatientsFiltersVisible() {
        this.patientsFiltersVisible = !this.patientsFiltersVisible
    }

    setProvidersFiltersVisible() {
        this.providersFiltersVisible = !this.providersFiltersVisible
    }

    emitFilterStatus() {
        const status = { value: true, name: 'activo' };
        this.statusFilterEmitter.emit(status);
      }

      timmer(){ //Forced disabled on get status
        this.disableActions = true;
        setTimeout(() => {
            this.disableActions = false
        }, 2000);
      }

      updateFromDate(value: Date) {
        this.fromDateSelected = value;
        this.fromDateToQps.emit(this.fromDateSelected);
    }

    onFilterFromDate(event: any): void {
        const filtered = this.fromDateList.find(f => f.id === parseFloat(event));
        if (filtered) {
            let index = this.fromDateList.indexOf(filtered);
            this.fromDateListSelected = this.fromDateList[index];
            this.updateFromDate(filtered.value.toDate());
        } else {
            console.error(' No se encontró un filtro válido');
        }
    }

    onFilterPatientsByStatus(status:PATIENT_STATUS, value: boolean) {
        if (status === PATIENT_STATUS.ACTIVE) {
            this.activePatientsSelected = value;
        } else if (status === PATIENT_STATUS.INACTIVE) {
            this.inactivePatientsSelected = value;
        }
        this.patientByStatusFilter.emit({ value: !value, status: status});
    }


    ngOnDestroy() {

    }


}
